import type { RxChangeDenialReasonT } from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * RxChange denial reasons accepted by DoseSpot's ``denyRxChange`` endpoint.
 * Aliased from the regenerated SDK so the union always tracks the OpenAPI
 * contract — never hand-extend here, regen the SDK instead.
 */
export type RxChangeDenialReason = RxChangeDenialReasonT;

/**
 * Human-readable label for every ``RxChangeDenialReason``. Exhaustive
 * ``Record`` shape — adding a value to the SDK enum breaks compilation here
 * until a label is supplied, which keeps the UI in lock-step with backend
 * acceptance.
 */
export const RX_CHANGE_DENIAL_REASON_LABELS: Readonly<Record<RxChangeDenialReason, string>> = {
  DeniedPatientUnknown: 'Patient unknown',
  DeniedPatientNotUnderCare: 'Patient not under care',
  DeniedPatientNoLongerUnderPatientCare: 'Patient no longer under care',
  DeniedNeverPrescribed: 'Never prescribed',
  DeniedHavePatientContact: 'Have patient contact',
  DeniedChangeInappropriate: 'Change inappropriate',
  DeniedNeedAppointment: 'Need appointment',
  DeniedPrescriberNotAssociateWithLocation: 'Prescriber not associated with location',
  DeniedNoPriorAuthAttempt: 'No prior auth attempt',
  DeniedAlreadyHandled: 'Already handled',
  DeniedAtPatientRequest: 'At patient request',
  DeniedPriorAuthNoAttempt: 'Prior auth — no attempt',
  DeniedPriorAuthInProgress: 'Prior auth in progress',
  DeniedOrderNotFound: 'Order not found',
  DeniedPayerNoPriorAuth: 'Payer — no prior auth',
  DeniedPatientNoRecord: 'No patient record',
  DeniedOrderExpired: 'Order expired',
  DeniedPharmacyNotRecognized: 'Pharmacy not recognized',
};

export function rxChangeDenialReasonLabel(reason: RxChangeDenialReason): string {
  return RX_CHANGE_DENIAL_REASON_LABELS[reason];
}

export interface RxChangeDenialReasonOption {
  readonly value: RxChangeDenialReason;
  readonly label: string;
}

/** Ready-to-use list for ``<Select>``-style UIs, in canonical SDK order. */
export const RX_CHANGE_DENIAL_REASON_OPTIONS: ReadonlyArray<RxChangeDenialReasonOption> =
  Object.entries(RX_CHANGE_DENIAL_REASON_LABELS).map(([value, label]) => ({
    value: value as RxChangeDenialReason,
    label,
  }));

/** Sensible anchor reason for new RxChange deny drafts — see refill counterpart. */
export const DEFAULT_RX_CHANGE_DENIAL_REASON: RxChangeDenialReason = 'DeniedChangeInappropriate';
